export default __webpack_public_path__ + "static/media/customers.b55242d3.jpg";